import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {BaseurlService} from '../../services/baseurl.service';

@Injectable({
  providedIn: 'root'
})
export class PoiDeployedVersionService {

  constructor(
    private http: HttpClient,
    private baseUrl: BaseurlService,
  ) { }

  getInfo(): Observable<JirasulInfo> {
    return this.http.get<JirasulInfo>(`${this.baseUrl.getBaseUrl()}/jirasul`);
  }
}


export interface JirasulInfo {
  toMarketingVersions: Record<string, string>
  currentVersion: Record<string, Record<string, { seenVersion: string }>>;
  currentState: Record<string, Record<string, { commit: string; date: string }>>;
  modules: string[];
  stages: string[];

}
